<script>
export default {
    props: ['data', 'type'],
    name: "productSwiper",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                // slidesPerView: 4,
                // slidesPerGroup: 4,
                // spaceBetween: '3.5714%',
            },
        };
    },
    computed: {
        list() { 
            return Object.groupBy(this.data, (v, i) => parseInt(i / 4));
        },
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {
        toLink(item) { 
            let path;
            if (this.type == 'goods') {
                path = `/shop/detail?id=${item.id}`;
            } else if (this.type == 'series') { 
                path = `/shop/category/${item.category_parent_id}/filter?id=${item.category_id}`;
            }
            if (path) { 
                this.$router.push(path);
            }
        }
    },
};
</script>

<template>
    <swiper class="product_swiper" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="group flex">
                <div class="item" @click="toLink(_item)" v-for="(_item, _index) in item" :key="_index">
                    <div class="layout_bg bg" :style="`background-image: url(${_item.image});`"></div>
                    <div class="text flex flex_column justify_end">
                        <p class="type" v-if="_item.desc && type == 'goods'">{{ _item.desc }}</p>
                        <p class="name">{{ _item.name }}</p>
                        <p class="price" v-if="type == 'goods'">RMB {{ _item.price }}</p>
                        <template v-if="type == 'series'">
                            <p class="desc" v-if="_item.desc" v-html="$textToHtml(_item.desc)"></p>
                            <p class="choose">选购系列</p>
                        </template>
                    </div>
                </div>
            </div>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination" v-if="list.length > 1"></div>
    </swiper>
</template>

<style scoped lang="scss">
.product_swiper{
    margin: 0 -.4rem;
    // padding: 0 .4rem;
    @media only screen and (max-width: 750px) {
        margin: 0 -.3rem;
    }
    .group{
        // width: 10.36rem;
        gap: .4rem;
        // margin: 0 auto;
        padding: 0 .4rem;
        .item{
            // flex: 1;
            width: 2.5rem;
            text-align: center;
            display: flex;
            flex-direction: column;
            font-size: .18rem;
            cursor: pointer;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
                .choose{
                    font-size: .22rem;
                    color: #666;
                }
            }
            .bg{
                height: 0;
                padding-bottom: 100%;
                // border: 1px solid #999;
                margin-bottom: .3rem;
            }
            .text{
                gap: .1rem;
                flex: 1;
            }
            .type{
                color: #d01600;
            }
        }
        @media only screen and (max-width: 750px) {
            flex-wrap: wrap;
            padding: 0 .3rem;
            gap: .3rem;
            .item{
                width: 3.3rem;
            }
        }
    }
    --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .2rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 1.25rem;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .2rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
        @media only screen and (max-width: 750px) {
            top: 45%;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
    .swiper-pagination{
        position: relative;
        left: auto;
        bottom: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .04rem;
        margin-top: .3rem;
        @media only screen and (max-width: 750px) {
            gap: .1rem;
        }
        /deep/.swiper-pagination-bullet{
            margin: 0;
            width: .08rem;
            height: .08rem;
            border: 1px solid #999;
            background: none;
            opacity: 1;
            &-active{
                background: #999;
            }
            @media only screen and (max-width: 750px) {
                width: .12rem;
                height: .12rem;
                border-color: #000;
                &-active{
                    background: #000;
                }
            }
        }
    }
}
</style>